/* eslint-disable consistent-return */
import Swal from "sweetalert2";
import { VAPID_PUBLIC_KEY } from "@config";
import { deletePushNotification, storePushNotification } from "@services/auth";
import { handleShowErrorPopup } from "@utils/handleShowErrorPopup";
import { ERROR_CODE_PUSH_NOTIFICATION } from "@config/constants";
import { urlBase64ToUint8Array } from "../helper";

const messageWarningNotSupport =
  "<p class='content-warning'>通知を受信するには、以下の設定をご確認ください。<br/><br/>1.ホーム画面に追加（iOSをご利用の場合）<br/>2.ホーム画面に追加後、デバイスでスマジョブの通知設定を有効にする（iOSをご利用の場合）<br/>3.ご利用のデバイスやブラウザが最新であることを確認する<br/><br/>詳細はマイページ > アカウント設定 > 通知設定をご覧ください。</p>";
export const registerServiceWorker = async (showWarning) => {
  if (!(await checkNotificationSupport(showWarning))) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js");
  } catch (error) {
    handleShowErrorPopup(error?.message, () => {});
    return null;
  }
};

export const checkNotificationSupport = async (showWarning) => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    if (showWarning) {
      Swal.fire({
        icon: "error",
        html: messageWarningNotSupport,
        allowOutsideClick: false,
      });
    }
    return false;
  }
  return true;
};

export const requestNotificationPermission = async (
  hasNotification,
  updateBySetting = true,
  showWarning = true
) => {
  const registration = await registerServiceWorker(showWarning);
  if (!registration) return;
  try {
    const sub = await registration?.pushManager?.getSubscription();
    if (sub === null && hasNotification) {
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
      const subscriptionObject = JSON.stringify(subscription);
      return storePushNotification(JSON.parse(subscriptionObject));
    }
    if (sub && hasNotification && updateBySetting) {
      return storePushNotification(JSON.parse(JSON.stringify(sub)));
    }
    if (sub && !hasNotification && updateBySetting) {
      return deleteNotification();
    }
  } catch (error) {
    if (error.code === ERROR_CODE_PUSH_NOTIFICATION.INCOGNITO_MODE) {
      showWarning &&
        Swal.fire({
          icon: "error",
          html: messageWarningNotSupport,
          allowOutsideClick: false,
        });
    } else if (error.code !== ERROR_CODE_PUSH_NOTIFICATION.SYSTEM) {
      handleShowErrorPopup(error?.message);
    }
  }
};

export const deleteNotification = async () => {
  const registration = await registerServiceWorker(false);

  if (!registration) return;

  const subscription = await registration.pushManager.getSubscription();
  if (subscription) {
    try {
      await subscription.unsubscribe();
      await deletePushNotification({ endpoint: subscription.endpoint });
    } catch (error) {
      handleShowErrorPopup(error?.message);
    }
  } else {
    await deletePushNotification({ endpoint: null });
  }
};
